import * as APSConstants from '../../constants';
import * as D from '../../deps';
import * as APSWorkers from '../workers';

export default [
  {
    actionType: APSConstants.APSActions.ADD_ITEM_FEEDBACK,
    handler: APSWorkers.addItemFeedback,
    concur: 'takeLatest',
  },
  {
    actionType: APSConstants.APSActions.ITEM_ENDED,
    handler: APSWorkers.itemEnded,
    concur: 'takeOnly',
  },
  {
    actionType: APSConstants.APSActions.PAUSE_SOURCE,
    handler: APSWorkers.pauseSource,
    concur: 'takeEvery',
  },
  {
    actionType: APSConstants.APSActions.PLAY_CURRENT_ITEM_FOR_SOURCE,
    handler: APSWorkers.playCurrentItem,
    concur: 'takeLatest',
  },
  {
    actionType: APSConstants.APSActions.PLAY_SOURCE,
    handler: APSWorkers.playSource,
    concur: 'takeLatest',
  },
  {
    actionType: APSConstants.APSActions.REFRESH_CURRENT_ITEM,
    handler: APSWorkers.refreshCurrentItem,
    concur: 'takeLatest',
  },
  {
    actionType: APSConstants.APSActions.PLAY_AD_ITEM,
    handler: APSWorkers.playAdItem,
    concur: 'takeLatest',
  },
  {
    actionType: APSConstants.APSActions.RESET_CURRENT_SOURCE,
    handler: APSWorkers.resetCurrentSource,
    concur: 'takeLatest',
  },
  {
    actionType: APSConstants.APSActions.REMOVE_ITEM_FEEDBACK,
    handler: APSWorkers.removeItemFeedback,
    concur: 'takeLatest',
  },
  {
    actionType: APSConstants.APSActions.REPEAT_SOURCE,
    handler: APSWorkers.repeatSource,
    concur: 'takeLatest',
  },
  {
    actionType: APSConstants.APSActions.REPLAY_ITEM,
    handler: APSWorkers.replayItem,
    concur: 'takeOnly',
  },
  {
    actionType: APSConstants.APSActions.RESUME_SOURCE,
    handler: APSWorkers.resumeSource,
    concur: 'takeLatest',
  },
  {
    actionType: APSConstants.APSActions.SHUFFLE_SOURCE,
    handler: APSWorkers.shuffleSource,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.Api.ApiActions.PLAYBACK_CURRENT_SUCCESS,
    handler: APSWorkers.loadArtistThroughSources,
    concur: 'takeLatest',
  },
  {
    actionType: APSConstants.APSActions.SKIP_ITEM,
    handler: APSWorkers.skipItem,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.PLAYING,
    handler: APSWorkers.itemStarted,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.UPDATE,
    handler: APSWorkers.itemUpdate,
    concur: 'throttle',
    wait: 1000, // 1 second
  },
];
